<template>
    <v-container>

        <v-row>
            <v-col md="12">
                <h1 class="font-weight-medium">{{$t('Bodegas')}}</h1>
            </v-col>
        </v-row>

        <v-row>

        </v-row>

        <v-row>
            <v-col md="2">
                <v-checkbox v-model="tienda_online" :label="$t('Tienda Online')"></v-checkbox>
            </v-col>
            <v-col md="2">
                <v-checkbox v-model="enoturismo" :label="$t('Enoturismo')"></v-checkbox>
            </v-col>


            <v-col md="2">
                <v-select
                        :label="$t('Produción')"
                        :items="productions"
                        :item-text="'name'"
                        :item-value="'id'"
                        :multiple="true"
                        filled
                        v-model="production"
                        maxlength="250"
                ></v-select>



            </v-col>
            <v-col md="2">
                <v-select
                        :label="$t('Zona')"
                        :items="zonas"
                        :item-text="'name'"
                        :item-value="'id'"
                        filled
                        v-model="zona"
                        maxlength="250"
                ></v-select>
            </v-col>
            <v-col md="2">
                <v-select
                        :label="$t('Categorías de Cava')"
                        :items="categorias"
                        :multiple="true"
                        :item-text="'name'"
                        :item-value="'id'"
                        filled
                        v-model="categoria"
                        maxlength="250"
                ></v-select>
            </v-col>

            <v-col md="2">
            <v-text-field
                    :label="$t('Nombre')"
                    filled
                    v-model="text"
                    maxlength="250"
            ></v-text-field>
            </v-col>

            <v-col md="12" class="text-right pt-0 mt-0 pb-0">
                <v-btn @click="search()" large color="primary" dark>
                    {{$t('buscar')}}
                </v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-simple-table>
                    <template v-slot:default>
                        <thead>
                        <tr>
                            <th class="text-left">{{$t('Nombre')}}</th>
                            <th class="text-left">{{$t('Zona')}}</th>
                            <th class="text-left"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in data" :key="item.nombre_comercial">
                            <td><router-link  :to="{ name: 'bodegaid', params: { id: item.id }}">{{ item.nombre_comercial }}</router-link ></td>
                            <td>{{ item.zona }}</td>
                            <td>
                                <v-btn color="primary" dark small :to="{ name: 'bodegaid', params: { id: item.id }}">
                                    {{$t('Ver')}}
                                </v-btn>
                            </td>
                        </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>


        <v-row >

            <v-pagination
                    v-model="page"
                    :length="length"
                    :page="page"
                    total-visible="5"
            ></v-pagination>
        </v-row>



    </v-container>
</template>


<script>

    import axios from "axios"
    import 'url-search-params-polyfill';


    export default {
        data() {
            return {
                page: 1,
                text: "",
                datax: "",
                length:6,
                data:[],
                tienda_online:null,
                produccion_biodinamica:false,
                enoturismo:false,
                production : null,
                productions:[
                    {
                        id:"produccion_integral",
                        name:"Producción integral"
                    },
                    {
                        id:"produccion_organica",
                        name:"Producción orgánica"
                    },
                    {
                        id:"produccion_biodinamica",
                        name:"Producción biodinamica"
                    }
                ],

                zonas:[
                    {
                        id:"B",
                        name:"Comtats De Barcelona"
                    },
                    {
                        id:"E",
                        name:"Valle Del Ebro"
                    }
                    ,
                    {
                        id:"A",
                        name:"Viñedos De Almendralejo"
                    }
                    ,
                    {
                        id:"L",
                        name:"Altos De Levante"
                    }
                ],
                zona:[],
                categoria:[],
                categorias:[
                    {
                        id:"joven",
                        name:"Cava de Guarda"
                    },
                    {
                        id:"reserva",
                        name:"Cava de Guarda Superior Reserva"
                    },
                    {
                        id:"gran_reserva",
                        name:"Cava de Guarda Superior Gran Reserva"
                    },
                    {
                        id:"paraje",
                        name:"Cava de Guarda Superior de Paraje Calificado"
                    },
                ]
            };
        },
        methods:{
            search() {
                let data = {};
                if (this.text) {
                    this.page=1
                    data.nombre_comercial__unaccent__icontains = this.text
                }
                if (this.tienda_online) {
                    this.page=1
                    data.tienda_online = this.tienda_online
                }
                if (this.enoturismo) {
                    this.page=1
                    data.enoturismo = this.enoturismo
                }
                if (this.production) {
                    this.production.forEach((item) => {
                       data[item] = true
                    })
                }
                if (this.zona) {
                    data.zona = this.zona
                }
                if (this.categoria) {
                    this.categoria.forEach((item) => {
                       data[item] = true
                    })
                }

                data.page = this.page

                this.datax = data

                const searchParams = new URLSearchParams(data);
                const jwt = this.$store.state.jwt

                const config = {
                    headers: {Authorization: "Bearer " + jwt},
                    params: searchParams
                };

                return axios.get(this.$store.state.endpoints.bodegas, config)
                    .then((response) => {
                        this.data = response.data.results
                        this.length = Math.ceil(response.data.count/10)
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
        },
        watch: {
          // whenever question changes, this function will run
          page: function (newQuestion, oldQuestion) {
            this.search()
          }
        },
        mounted() {
            this.search()
        }
    };
</script>

<style>
    .disable-events {
        pointer-events: none
    }

</style>





